'use strict';

var FlightManagementConstants = {
  GRIDS: {
    FLIGHT_SUMMARY: 'flight-summary',
    INVENTORY_MANAGEMENT: 'inventory-management',
    OVERBOOKING_MANAGEMENT: 'overbooking-management',
    SERVICE_MANAGEMENT: 'service-management',
    DEMAND_MANAGEMENT: 'demand-management'
  }
};
module.exports = FlightManagementConstants;